<template>
  <div
    class="form-signature control-group"
    :class="{ error: error }"
  >
    <label class="control-label">
      <abbr
        v-if="required"
        title="Verplicht veld"
      > * </abbr>
      {{ label }}
    </label>
    <div class="signature-container">
      <vue-signature-pad
        ref="signaturePad"
        :options="{ onEnd: change }"
        width="100%"
        height="100px"
      />
    </div>
    <a
      v-if="environment !== 'registration-pdf'"
      class="form-signature__clear"
      @click="clear"
    > Leeg maken </a>
    <span
      v-if="error && error.input"
      class="help-inline"
    >
      {{ error.input }}
    </span>
  </div>
</template>

<script>
import VueSignaturePad from 'vue-signature-pad';

export default {
  name: 'FormSignature',

  components: {
    VueSignaturePad,
  },

  schema: [
    {
      name: 'label',
      default: 'Handtekening',
      type: 'FormText',
      label: 'Label',
    },
    {
      name: 'required',
      default: false,
      type: 'FormCheckbox',
      label: 'Verplicht',
    },
  ],

  props: {
    label: {
      type: String,
      default: '',
    },
    value: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Object,
      default: () => null,
    },
    environment: {
      type: String,
      required: true,
    },
  },

  mounted() {
    if (this.value) {
      this.$refs.signaturePad.fromDataURL(this.value);
    }
  },

  methods: {
    clear() {
      this.$refs.signaturePad.clearSignature();
      this.$emit('input', null);
    },
    change() {
      const { data } = this.$refs.signaturePad.saveSignature();
      this.$emit('input', data);
    },
  },
};
</script>

<style lang="scss">
.form-signature {
  display: flex;
  flex-grow: 1;

  label.control-label {
    width: 50%;
    font-size: 14px;
    line-height: 30px;
    margin-right: 20px;
    padding-left: 40px;
    text-align: left;
  }

  .signature-container {
    width: 50%;
    // margin-right: 10px;
  }

  .vue-signature-pad {
    width: 50%;
    margin-left: 50px;
  }

  canvas {
    border: 1px solid #ccc;
    border-radius: 4px;
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
    line-height: 30px;
  }

  &__clear {
    align-self: flex-start;
    width: 0;
    cursor: pointer;
    color: #c2bd00;
    right: 55px;
    position: relative;
    top: 5px;
  }
}
</style>
